import {
  Dialog,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import React from 'react';
import { Close as CloseIcon } from '@material-ui/icons';
import styled from 'styled-components';
import { WrappedTableCell } from '../../../common/WrappedTableCell';
import { HazardCardInfoTable } from '../Hazard.interface';

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
  .title {
    flex: 1;
  }
`;

export interface HazardCardInfoDialogProps {
  title: string;
  table: HazardCardInfoTable;
  onClose: () => void;
}

export const HazardCardInfoDialog: React.FC<HazardCardInfoDialogProps> = ({
  title,
  table,
  onClose
}) => {
  return (
    <Dialog open maxWidth='xl'>
      <StyledDialogTitle disableTypography>
        <Typography variant='h6' className='title'>
          {title}
        </Typography>
        <IconButton size='small' onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {table.head.map((item, index) => (
                <WrappedTableCell key={index}>{item}</WrappedTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {table.body.map((row, index) => (
              <TableRow key={index}>
                {row.map((item, index) => (
                  <WrappedTableCell key={`cell-${index}`}>
                    {item}
                  </WrappedTableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Dialog>
  );
};
